/// <summary name='cafm.cache' type='Object'>Container object for CAFM JS caching code, uses localStorage</summary>
cafm.cache = {
    isAvailable: function () {
        /// <summary>Checks if localStorage is supported and returns an instance of it if successful</summary>
        var storage;
        var fail;
        var uid;
        try {
            uid = new Date();
            storage = localStorage;
            storage.setItem(uid, uid);
            fail = storage.getItem(uid) != uid;
            storage.removeItem(uid);
            fail && (storage = false);
        } catch (exception) { }
        return storage;
    },
    set: function (k, v) {
        /// <summary>Adds/updates an item in the cafm js cache</summary>
        /// <param name="k" type="String">The cache item key</param>
        /// <param name="v" type="Object">The object to be cached</param>

        localStorage.setItem(k, typeof (v) == 'object' ? JSON.stringify(v) : v);
    },
    get: function (k, d) {
        /// <summary>Gets an item from the cafm js cache</summary>
        /// <param name="k" type="String">The cache item key</param>
        /// <param name="d" type="Object">Default return value if no cache item exists</param>
        /// <returns type="Object">The cached object or null if not found</returns>

        var v = localStorage.getItem(k);
        if (v && typeof (v) == 'string') v = JSON.safeParse(v);
        return v != null || isUndefined(d) ? v : d;
    },
    clearAll: function (excludeKeys) {
        /// <summary>Clears CAFM items from the cafm js cache</summary>
        /// <param name="excludeKeys" type="Array">Optional array of keys to not clear</param>

        for (var key in window.localStorage) {

            if (!excludeKeys || !cafm.util.exists(excludeKeys, function (k) { return k == key; })) {

                cafm.cache.remove(key);
            }
        }
    },
    exists: function (k) {
        /// <summary>Determines if an item from the cafm js cache exists</summary>
        /// <param name="k" type="String">The cache item key</param>
        /// <returns type="Boolean">True if the cache item exists and is not null</returns>

        var v = localStorage.getItem(k);
        return isDefined(v) && v != null;
    },
    remove: function (k) {
        /// <summary>Removes an item from the cafm js cache</summary>
        /// <param name="k" type="String">The cache item key</param>

        localStorage.removeItem(k);
    },
    addObject: function (jo) {
        /// <summary>Adds json data to the client cache, can be a collection or single object</summary>
        /// <param name="jo" type="IClientCacheable">Json object implementing IClientCacheable</param>

        if (jo && jo.IsCacheable && (jo.CacheKey || jo.CachingHandler)) {

            // check for a caching handler object
            if (isStr(jo.CachingHandler)) {

                var ch = cafm.util.getReference(jo.CachingHandler);

                if (isObj(ch)) {

                    if (jo.Items) {

                        ch.addItems(jo);

                        if (isFunc(ch.syncItems)) {

                            ch.syncItems();
                        }
                    }
                    else {
                        ch.addItem(jo);
                    }
                }
            }
            else {

                if (jo.Items) {
                    cafm.cache.set(jo.CacheKey, jo.Items);
                }
                else {
                    cafm.cache.set(jo.CacheKey, jo);
                }
            }

        }
    },
    getObject: function (jo) {
        /// <summary>Adds json data to the client cache, can be a collection or single object</summary>
        /// <param name="jo" type="IClientCacheable">Json object implementing IClientCacheable</param>

        if (jo && jo.IsCacheable && jo.CacheKey) {

            return cafm.cache.get(jo.CacheKey);
        }
        else {

            return null;
        }
    },
    session: {

        set: function (k, v) {
            /// <summary>Adds/updates an item in the cafm js session cache</summary>
            /// <param name="k" type="String">The cache item key</param>
            /// <param name="v" type="Object">The object to be cached</param>

            sessionStorage.setItem(k, typeof (v) == 'object' ? JSON.stringify(v) : v);
        },
        get: function (k, d) {
            /// <summary>Gets an item from the cafm js session cache</summary>
            /// <param name="k" type="String">The cache item key</param>
            /// <param name="d" type="Object">Default return value if no cache item exists</param>
            /// <returns type="Object">The cached object or null if not found</returns>

            var v = sessionStorage.getItem(k);
            if (v && typeof (v) == 'string') v = JSON.safeParse(v);
            return v || isUndefined(d) ? v : d;
        },
        remove: function (k) {
            /// <summary>Removes an item from the cafm js session cache</summary>
            /// <param name="k" type="String">The cache item key</param>

            sessionStorage.removeItem(k);
        },
        exists: function (k) {
            /// <summary>Determines if an item from the cafm js session cache exists</summary>
            /// <param name="k" type="String">The cache item key</param>
            /// <returns type="Boolean">True if the cache item exists and is not null</returns>

            var v = sessionStorage.getItem(k);
            return isDefined(v) && v != null;
        }
    },
    _pageCache: {},
    page: function (key, createFunction, execFunction) {
        let res;
        if (cafm.cache._pageCache[key]) res = cafm.cache._pageCache[key];
        res = cafm.cache._pageCache[key] = createFunction();
        if (execFunction) execFunction(res);
        return res;
    }
}